<template>
  <article class="popup popup-padding add-project-popup">
    <header class="popup-top">
      <h2 class="title">
        {{$t('projects.addProject.title')}}
      </h2>
      <div class="popup-top_btns">
        <question-btn :text="$t('prompts.addProject')"></question-btn>
        <close-btn class="static"></close-btn>
      </div>
    </header>
    <form class="add-project-form" @submit.prevent="createProject">
      <label class="input-cont input-cont_small" :class="{'error': $v.name.$error}">
        <p class="label">{{$t('roles.filters.name')}}</p>
        <input type="text"
               v-model="name"
               @blur="$v.name.$touch()"
               @focus="$v.name.$reset()"
               placeholder="Проект">
        <errors v-show="$v.name.$error"></errors>
      </label>
      <upload-avatar :label="$t('projects.addProject.uploadAvatar')"
                     @del="avatarFile = ''"
                     @upload="avatarFile = $event"></upload-avatar>
      <div class="select-cont select-cont_multiple">
        <p class="label">
          {{$t('projects.addProject.usersSelect')}}
        </p>
        <v-select multiple
                  :searchable="true"
                  v-model="users"
                  :clearable="false"
                  label="email"
                  :options="usersArr"></v-select>
      </div>
      <label class="textarea-wrap">
        <p class="label">{{$t('forms.descLb')}}</p>
        <textarea v-model="desc"
                  :placeholder="$t('forms.descPl')"></textarea>
      </label>
      <div class="btns-bottom">
        <button type="button"
                :disabled="loading"
                @click="closeAll"
                class="btn btn-transparent_blue">{{$t('btns.cancel')}}</button>
        <button type="submit"
                :disabled="loading || $v.$anyError || disabled"
                :class="{'loading': loading}"
                class="btn btn-blue">{{$t('btns.create')}}</button>

      </div>

    </form>
  </article>
</template>

<script>
  import closeBtn from '../closeBtn'
  import questionBtn from '../questionBtn'
  import {popups} from "../../../mixins/popups";
  import errors from '../../Forms/errors'
  import {required} from 'vuelidate/lib/validators'
  import uploadAvatar from '../../uploadAvatar'
  import {toFormData} from "../../../mixins/utils/toFormData";
  import {mapActions} from 'vuex'
  import {filters} from "../../../mixins/filters";
  import {usersInAccount} from "../../../mixins/utils/usersInAccount";

  export default {
    name: 'addProjectPopup',
    mixins: [popups, toFormData, filters, usersInAccount],
    components: {
      closeBtn,
      questionBtn,
      errors,
      uploadAvatar
    },
    data() {
      return {
        name: '',
        avatarFile: '',
        desc: '',
        users: [],
        loading: false
      }
    },
    computed: {
      disabled() {
        return !this.name
      }
    },
    methods: {
      ...mapActions({
        addProject: 'projects/createProject',
        getProjects: 'projects/getProjects',
        setPermissions: 'projects/setPermissions',

      }),
      async createProject() {
        this.loading = true;
        let data = {
          name: this.name,
          description: this.desc
        };
        if (this.avatarFile) {
          data.image = this.avatarFile
        };

        let users;
        if (this.users.length) {
          users = this.users.map(item => item.email).join(',')
        }

        let formData = this.toFormData(data);
        await this.addProject(formData)
          .then(async (res) => {
            let projectId = res.data.id;

            if (users) {
              await  setPermissionProject(this, projectId);
            };


            await this.getProjects();
            this.closeAll();
          })
          .catch(e => {
            console.log(e)
          });

        async function setPermissionProject(cntx, id) {
          let permission = {
            value: 4,
            project_id: id,
            emails: users
          };

          await cntx.setPermissions({data: permission});
        }
        this.loading = false;
      }
    },
    validations: {
      name: {
        required
      }
    }
  }
</script>

<style lang="scss" scoped>
  .avatar-cont {
    margin: 20px 0;
  }

  .select-cont {
    margin-bottom: 20px;
  }
</style>
